import React from 'react'

const ThirdTop = () => {
    const top={
        backgroundColor:'rgb(255, 6, 151)',
        color: 'rgb(255, 6, 151)',
    }
  return (
    <>
    <div style={top}>
        .
    </div>
    </>
  )
}

export default ThirdTop